import { Component, OnInit, ViewChild } from '@angular/core';
import {
  ClientDTO,
  DeviceStatusReportParameterDTO,
  FilterDTO,
  FilterOperator,
  ZoneDeviceBrand,
  ZoneDeviceDirection,
  ZoneDeviceDTO,
  ZoneDeviceState,
  ZoneDeviceType,
} from '../../../../../base/models/models.swagger.generated';
import { GridConstantsFactory } from '../../../../../base/shared/syncfusion/grid-constants-factory';
import { ClientService } from '../../../../../base/services/client/client.service';
import { UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { SaveOptions } from '../../../reports-footer/save-options';
import { reportsRoute } from '../../../../../core/routing/route-names';
import { DeviceStatusReportService } from '../device-status-report.service';
import { SpinnerService } from '../../../../../base/spinner/spinner.service';
import { DataManager } from '@syncfusion/ej2-data';
import { AvpCustomAdaptor } from '../../../../../base/shared/syncfusion/avp-custom-adaptor';
import { GridComponent, GridModule } from '@syncfusion/ej2-angular-grids';
import { ReportsFooterComponent } from '../../../reports-footer/reports-footer.component';
import { DateTime } from 'luxon';
import { TranslateModule } from '@ngx-translate/core';
import { DeviceStatusFormComponent } from '../device-status-form/device-status-form.component';
import { TitleBarComponent } from '../../../../../base/shared/title-bar/title-bar.component';

@Component({
    selector: 'app-device-status-report',
    templateUrl: './device-status-report.component.html',
    styleUrls: ['./device-status-report.component.scss'],
    imports: [
        TitleBarComponent,
        DeviceStatusFormComponent,
        GridModule,
        ReportsFooterComponent,
        TranslateModule,
    ]
})
export class DeviceStatusReportComponent implements OnInit {

  @ViewChild('grid') public grid: GridComponent;
  @ViewChild(ReportsFooterComponent) public footer: ReportsFooterComponent;

  public get selectedClient(): ClientDTO {
    return this.clientService.selectedClient;
  }

  public data: DataManager;
  public filterForm = this.fb.group({
    zoneId: [null],
  });

  public pageSettings = GridConstantsFactory.createStandardPageSettings();

  constructor(private clientService: ClientService,
              private fb: UntypedFormBuilder,
              private router: Router,
              private spinnerService: SpinnerService,
              private deviceStatusReportService: DeviceStatusReportService) {
  }

  public ngOnInit(): void {
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.deviceStatusReportService, this.spinnerService),
    });

    if (this.selectedClient) {
      this.searchReports();
    }
  }

  public searchReports(): void {
    const filters = [];

    if (this.filterForm.get('zoneId').value) {
      filters.push(new FilterDTO({
        isComplex: false,
        field: 'ZoneId',
        operator: FilterOperator.Equal,
        value: this.filterForm.get('zoneId').value,
      }));
    }

    this.deviceStatusReportService.filters = filters;
    try {
      this.grid?.refresh();
    } catch (e) {
      // Ignore error when grid is in transition state
    }
  }

  public saveReport(saveOptions: SaveOptions): void {
    this.spinnerService.show();
    const deviceStatusReportParameterDTO = new DeviceStatusReportParameterDTO({
      zoneId: this.filterForm.get('zoneId').value
    });

    this.deviceStatusReportService.exportReport(deviceStatusReportParameterDTO, saveOptions)
      .subscribe(savedReportFileDTO => {
        this.spinnerService.hide();
        if (saveOptions.saveReport) {
          this.router.navigate([reportsRoute]);
        } else {
          this.footer.downloadFile(savedReportFileDTO);
        }
      });
  }

  public formatDeviceType(type: ZoneDeviceType): string {
    return 'i18n.shared.zone-device-enums.device-type.' + ZoneDeviceType[type];
  }

  public formatDeviceBrand(brand: ZoneDeviceBrand): string {
    return 'i18n.shared.zone-device-enums.brand.' + ZoneDeviceBrand[brand];
  }

  public formatDeviceDirection(direction: ZoneDeviceDirection): string {
    return 'i18n.shared.zone-device-enums.direction.' + ZoneDeviceDirection[direction];
  }

  public formatDeviceState(state: ZoneDeviceState, device:ZoneDeviceDTO): string {
    if (device.enabled) {
      return 'i18n.shared.zone-device-enums.state.' + ZoneDeviceState[state];
    } else {
      return 'i18n.shared.zone-device-enums.state.undefined';
    }

  }

  public getDeviceIpAddress(device: ZoneDeviceDTO): string {
    return this.deviceStatusReportService.deviceIpAddresses.get(device.id);
  }

  public markLastSignalRows(e: any): void {
    const row = e.row;
    const rowData = e.data;
    const fourHoursBefore = DateTime.now().minus({hours: 4});
    if (rowData.device.lastSignal && rowData.device.enabled) {
      if (rowData.device.lastSignal < fourHoursBefore) {
        row.classList.add('no-signal');
      } else if (rowData.device.enabled && (rowData.device.state == ZoneDeviceState.NotPresent)) {
        row.classList.add('no-signal');
      }
    } else if (!rowData.device.enabled) {
      row.classList.add('inactive');
    } else {
      row.classList.add('no-signal');
    }
  }

  public onRefresh() {
    this.grid.refresh();
  }
}
